import { createContext, Dispatch, SetStateAction, useContext } from "react";

export interface CrossSectionFieldsIface {
  address?: string;
}

export const CrossSectionFieldsIds = ["address"];

export const CrossSectionFields = createContext<CrossSectionFieldsIface>({});
export const SetCrossSectionFields = createContext<
  Dispatch<SetStateAction<CrossSectionFieldsIface>>
>(() => undefined);

export const useSetCrossSectionFields = () => useContext(SetCrossSectionFields);

export const useCrossSectionFields = () => useContext(CrossSectionFields);
